// extracted by mini-css-extract-plugin
export default {"container":"TagSnpModalV4__container___QmGbc","standardListContainer":"TagSnpModalV4__standardListContainer___moRL3"};